import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CompositeFillingContent from '../components/CompositeFillingContent';

const CompositeFilling = () => {
  return (
    <div className="composite-fillings-container" style={{ backgroundColor: "#edffee" }}>
      <Header />
      <CompositeFillingContent />
      <Footer />
    </div>
  );
};

export default CompositeFilling;